export const monsterList = [
  {
    index: "goblin",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30783/955/1000/1000/638062024584880857.png",
  },
  {
    index: "giant-rat",
    img: "https://www.dndbeyond.com/avatars/70/273/636463305245423768.png",
  },
  {
    index: "dust-mephit",
    img: "https://www.dndbeyond.com/avatars/thumbnails/34175/931/1000/1000/638190241938100148.png",
  },
  {
    index: "ice-mephit",
    img: "https://www.dndbeyond.com/avatars/thumbnails/34175/909/1000/1000/638190241405142934.png",
  },
  {
    index: "magma-mephit",
    img: "https://www.dndbeyond.com/avatars/thumbnails/31079/74/1000/1000/638074037477949301.png",
  },
  {
    index: "steam-mephit",
    img: "https://www.dndbeyond.com/avatars/thumbnails/34175/946/1000/1000/638190242330361682.png",
  },
  {
    index: "bandit",
    img: "https://www.dndbeyond.com/avatars/thumbnails/0/181/1000/1000/636252761965117015.jpeg",
  },
  {
    index: "gray-ooze",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30834/153/1000/1000/638063882595415196.png",
  },
  {
    index: "spy",
    img: "https://www.dndbeyond.com/attachments/2/656/humanoid.jpg",
  },
  {
    index: "flying-snake",
    img: "https://www.dndbeyond.com/avatars/thumbnails/16/517/1000/1000/636376319640572721.jpeg",
  },
  {
    index: "mimic",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30833/408/1000/1000/638063863232165584.png",
  },
  {
    index: "animated-armor",
    img: "https://www.dndbeyond.com/avatars/thumbnails/31312/506/1000/1000/638084408333616236.png",
  },
  {
    index: "harpy",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30788/677/1000/1000/638062178962566030.png",
  },
  {
    index: "grimlock",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30784/270/1000/1000/638062035227436078.png",
  },
  {
    index: "zombie",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30836/823/1000/1000/638063945376881949.png",
  },
  {
    index: "skeleton",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30835/849/1000/1000/638063922565505819.png",
  },
  {
    index: "dire-wolf",
    img: "https://www.dndbeyond.com/avatars/thumbnails/16/484/1000/1000/636376300478361995.jpeg",
  },
  {
    index: "kobold",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30832/207/1000/1000/638063832924455756.png",
  },
  {
    index: "shambling-mound",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30835/836/1000/1000/638063922372165925.png",
  },
  {
    index: "sahuagin",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30835/789/1000/1000/638063921569706098.png",
  },
  {
    index: "ghoul",
    img: "https://www.dndbeyond.com/avatars/thumbnails/14/483/1000/1000/636364323937041514.png",
  },
  {
    index: "gnoll",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30784/505/1000/1000/638062044385041691.png",
  },
  {
    index: "orc",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30834/160/1000/1000/638063882785865067.png",
  },
  {
    index: "lizardfolk",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30832/479/1000/1000/638063839674591734.png",
  },
  {
    index: "ankheg",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30761/865/1000/1000/638061096692582271.png",
  },
  {
    index: "cult-fanatic",
    img: "https://www.dndbeyond.com/avatars/thumbnails/0/259/1000/1000/636252768307230924.jpeg",
  },
  {
    index: "gibbering-mouther",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30784/554/1000/1000/638062046140139699.png",
  },
  {
    index: "black-dragon-wyrmling",
    img: "https://www.dndbeyond.com/avatars/thumbnails/16/496/1000/1000/636376308217017511.jpeg",
  },
  {
    index: "blue-dragon-wyrmling",
    img: "https://www.dndbeyond.com/avatars/thumbnails/21222/242/1000/1000/637708181281501343.jpeg",
  },
  {
    index: "brass-dragon-wyrmling",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30782/475/1000/1000/638061963543984454.png",
  },
  {
    index: "bronze-dragon-wyrmling",
    img: "https://www.dndbeyond.com/avatars/thumbnails/16/492/1000/1000/636376306909593829.jpeg",
  },
  {
    index: "copper-dragon-wyrmling",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30782/536/1000/1000/638061965633505640.png",
  },
  {
    index: "gold-dragon-wyrmling",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30782/562/1000/1000/638061966416208867.png",
  },
  {
    index: "green-dragon-wyrmling",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30782/393/1000/1000/638061960809474996.png",
  },
  {
    index: "red-dragon-wyrmling",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30782/412/1000/1000/638061961411525220.png",
  },
  {
    index: "silver-dragon-wyrmling",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30782/730/1000/1000/638061973263583027.png",
  },
  {
    index: "white-dragon-wyrmling",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30782/441/1000/1000/638061962420535703.png",
  },
  {
    index: "awakened-shrub",
    img: "https://i.imgur.com/abNTNG1.png",
  },
  {
    index: "green-hag",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30788/618/1000/1000/638062177566175594.png",
  },
  {
    index: "imp",
    img: "https://www.dndbeyond.com/avatars/thumbnails/30782/21/1000/1000/638061948417487055.png",
  },
  {
    index: "giant-centipede",
    img: "https://www.vhv.rs/dpng/d/441-4413114_dungeons-and-dragons-giant-centipede-hd-png-download.png",
  },
];
